import React from 'react';
import { Check } from 'lucide-react';
export function ProductPresentation() {
  const benefits = ['sviluppare calma e concentrazione', 'migliorare coordinazione ed equilibrio', 'riconoscere ed esprimere le emozioni', 'rilassarsi nei momenti di stress', 'imparare divertendosi'];
  return <section className="py-16 px-4 bg-white" data-id="element-196">
      <div className="max-w-3xl mx-auto" data-id="element-197">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-198">
          Potrai guidare attività che aiutano i bambini a:
        </h2>

        <div className="grid gap-4" data-id="element-199">
          {benefits.map((benefit, index) => <div key={index} className="flex items-center p-5 bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-shadow" data-id="element-200">
              <div className="flex-shrink-0" data-id="element-201">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-202">
                  <Check className="w-6 h-6 text-green-600" data-id="element-203" />
                </div>
              </div>
              <p className="ml-5 text-lg text-gray-800 font-medium" data-id="element-204">
                {benefit}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}